<template>
  <div class="applications-list">
    <h3 class="mb-4">Mes candidatures</h3>

    <!-- Message si aucune candidature -->
    <div v-if="applications.length === 0" class="alert alert-info">
      Vous n'avez pas encore soumis de candidature.
    </div>

    <!-- Liste des candidatures -->
    <div v-else class="row">
      <div v-for="application in applications" :key="application.id" class="col-md-6 mb-4">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">{{ application.job_offer.title }}</h5>
            <span :class="getStatusBadgeClass(application.status)">
              {{ getStatusLabel(application.status) }}
            </span>
          </div>
          
          <div class="card-body">
            <p class="text-muted">
              <i class="fas fa-calendar-alt me-2"></i>
              Soumise le {{ formatDate(application.created_at) }}
            </p>
            
            <!-- Tests psychométriques si présélectionné -->
            <div v-if="application.status === 'preselected' && application.tests" class="tests mt-3">
              <h6>Tests à passer :</h6>
              <div class="progress mb-2">
                <div class="progress-bar" role="progressbar" 
                     :style="{ width: getTestProgress(application) + '%' }"
                     :aria-valuenow="getTestProgress(application)"
                     aria-valuemin="0" 
                     aria-valuemax="100">
                  {{ application.tests.completed }}/{{ application.tests.total }} tests complétés
                </div>
              </div>
              <div class="d-grid gap-2">
                <button
                  v-if="application.tests.completed < application.tests.total"
                  class="btn btn-primary"
                  @click="goToTests(application.id)"
                >
                  <span v-if="application.tests.completed === 0">
                    Commencer les tests
                  </span>
                  <span v-else>
                    Continuer les tests
                  </span>
                </button>
                <button
                  v-else
                  class="btn btn-success"
                  @click="goToMyResults(application.id)"
                >
                  <i class="fas fa-award me-2"></i>Voir mes résultats
                </button>
              </div>
            </div>

            <!-- Date limite pour l'offre -->
            <div class="mt-3">
              <small class="text-muted">
                Date limite de l'offre : {{ formatDate(application.job_offer.deadline) }}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationsList',

  data() {
    return {
      applications: []
    }
  },

  async created() {
    await this.loadApplications()
  },

  methods: {
    async loadApplications() {
      try {
        const response = await this.$http.get('/jobs/applications/my')
        this.applications = response.data.applications
      } catch (error) {
        console.error('Erreur lors du chargement des candidatures:', error)
        this.$toast.error('Erreur lors du chargement des candidatures')
      }
    },

    formatDate(date) {
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })
    },

    getStatusBadgeClass(status) {
      const classes = {
        pending: 'badge bg-warning',
        preselected: 'badge bg-info',
        selected: 'badge bg-success',
        rejected: 'badge bg-danger'
      }
      return classes[status] || 'badge bg-secondary'
    },

    getStatusLabel(status) {
      const labels = {
        pending: 'En attente',
        preselected: 'Présélectionné',
        selected: 'Sélectionné',
        rejected: 'Refusé'
      }
      return labels[status] || status
    },

    getTestProgress(application) {
      if (!application.tests) return 0
      return Math.round((application.tests.completed / application.tests.total) * 100)
    },

    goToTests(applicationId) {
      this.$router.push(`/applications/${applicationId}/tests`)
    },

    goToMyResults(applicationId) {
      this.$router.push({
        name: 'MyTestResults',
        params: { applicationId }
      })
    }
  }
}
</script>

<style scoped>
.progress {
  height: 25px;
}

.progress-bar {
  line-height: 25px;
  font-size: 0.9rem;
}

.card {
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.badge {
  font-size: 0.9rem;
  padding: 0.5em 0.8em;
}
</style> 